var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "task-sidebar", class: { "is-open": _vm.isOpen } },
      [
        _c("div", { staticClass: "task-sidebar-header" }, [
          _c("div", { staticClass: "task-sidebar-actions" }, [
            _vm.subprojectId && _vm.taskProjectId
              ? _c(
                  "button",
                  {
                    staticClass: "close-btn",
                    attrs: { type: "button", title: "Copia link" },
                    on: { click: _vm.copyTaskLink },
                  },
                  [_c("i", { staticClass: "fa fa-link" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.subprojectId
              ? _c(
                  "button",
                  {
                    staticClass: "close-btn",
                    attrs: {
                      type: "button",
                      title: _vm.isFollowing ? "Non seguire più" : "Segui",
                    },
                    on: { click: _vm.toggleFollow },
                  },
                  [
                    _c("i", {
                      staticClass: "fa",
                      class: _vm.isFollowing ? "fa-bell" : "fa-bell-o",
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close-btn",
                attrs: { type: "button" },
                on: { click: _vm.close },
              },
              [_c("i", { staticClass: "fa fa-times" })]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "task-sidebar-title" }, [
            !_vm.isCreationMode &&
            (_vm.taskData.code ||
              _vm.taskData.project_name ||
              _vm.taskData.parent_name)
              ? _c("div", { staticClass: "task-breadcrumb" }, [
                  _vm.taskData.code
                    ? _c("span", { staticClass: "breadcrumb-code" }, [
                        _vm._v(_vm._s(_vm.taskData.code)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.taskData.code &&
                  (_vm.taskData.project_name || _vm.taskData.parent_name)
                    ? _c("span", { staticClass: "breadcrumb-separator" }, [
                        _vm._v("·"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.taskData.project_name
                    ? _c("span", { staticClass: "breadcrumb-item" }, [
                        _vm._v(_vm._s(_vm.taskData.project_name)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.taskData.project_name && _vm.taskData.parent_name
                    ? _c("span", { staticClass: "breadcrumb-separator" }, [
                        _vm._v("›"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.taskData.parent_name
                    ? _c("span", { staticClass: "breadcrumb-item" }, [
                        _vm._v(_vm._s(_vm.taskData.parent_name)),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.canModify && !_vm.isPlanningMode && _vm.subprojectId
              ? _c(
                  "h4",
                  {
                    key: "sidebar-title-" + _vm.subprojectId,
                    ref: "titleInput",
                    staticClass: "editable-title",
                    attrs: { contenteditable: "true" },
                    on: {
                      input: _vm.handleTitleInput,
                      blur: _vm.saveTitleField,
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                        return $event.target.blur()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.taskData.name))]
                )
              : _c(
                  "h4",
                  {
                    key: "sidebar-title-readonly-" + _vm.subprojectId,
                    staticClass: "task-title-readonly",
                  },
                  [_vm._v(_vm._s(_vm.taskData.name || "Timesheet Progetto"))]
                ),
            _vm._v(" "),
            _vm.subprojectId && !_vm.isPlanningMode
              ? _c("div", { staticClass: "task-badges" }, [
                  _vm.canEditTaskStatus && _vm.taskStatusSelectOptions.length
                    ? _c(
                        "select",
                        {
                          staticClass:
                            "form-control input-sm task-sidebar-status-select",
                          domProps: { value: _vm.taskData.status },
                          on: {
                            change: function ($event) {
                              return _vm.saveTaskStatusFromSelect(
                                $event.target.value
                              )
                            },
                          },
                        },
                        _vm._l(_vm.taskStatusSelectOptions, function (opt) {
                          return _c(
                            "option",
                            { key: opt.slug, domProps: { value: opt.slug } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(opt.label) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm.taskData.status
                    ? _c(
                        "span",
                        {
                          staticClass: "badge",
                          style: _vm.statusBadgeStyle(_vm.taskData.status),
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.statusLabel(_vm.taskData.status)) +
                              "\n                    "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "task-sidebar-tabs" }, [
          _vm.isPlanningMode && _vm.assignmentData
            ? _c(
                "button",
                {
                  staticClass: "tab-btn",
                  class: { active: _vm.activeTab === "planning" },
                  on: {
                    click: function ($event) {
                      _vm.activeTab = "planning"
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-calendar-check-o" }),
                  _vm._v(" Pianificazione\n            "),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.subprojectId
            ? _c(
                "button",
                {
                  staticClass: "tab-btn",
                  class: { active: _vm.activeTab === "overview" },
                  on: {
                    click: function ($event) {
                      _vm.activeTab = "overview"
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-info-circle" }),
                  _vm._v(" Panoramica\n            "),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.subprojectId
            ? _c(
                "button",
                {
                  staticClass: "tab-btn",
                  class: { active: _vm.activeTab === "attachments" },
                  on: {
                    click: function ($event) {
                      _vm.activeTab = "attachments"
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-paperclip" }),
                  _vm._v(
                    " Allegati (" +
                      _vm._s(_vm.attachments.length) +
                      ")\n            "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isCreationMode
            ? _c(
                "button",
                {
                  staticClass: "tab-btn",
                  class: { active: _vm.activeTab === "timesheet" },
                  on: { click: _vm.loadTimesheetData },
                },
                [
                  _c("i", { staticClass: "fa fa-clock-o" }),
                  _vm._v(
                    " Timesheet (" +
                      _vm._s(_vm.timesheetEntries.length) +
                      ")\n            "
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "sidebarContent",
            staticClass: "task-sidebar-content",
            class: { "content-loading": _vm.isLoadingTask },
          },
          [
            _vm.isLoadingTask
              ? _c("div", { staticClass: "task-loading-overlay" }, [_vm._m(0)])
              : _vm._e(),
            _vm._v(" "),
            _vm.isPlanningMode && _vm.assignmentData
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab === "planning",
                        expression: "activeTab === 'planning'",
                      },
                    ],
                    staticClass: "tab-content planning-tab",
                  },
                  [
                    !_vm.isCreationMode
                      ? _c("div", { staticClass: "assignment-week-block" }, [
                          _c("div", { staticClass: "assignment-header" }, [
                            _c("div", { staticClass: "assignment-user" }, [
                              _vm.assignmentData.user.avatar
                                ? _c("img", {
                                    staticClass: "user-avatar-medium",
                                    attrs: {
                                      src: _vm.assignmentData.user.avatar,
                                      alt: _vm.assignmentData.user.full_name,
                                    },
                                  })
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "user-avatar-placeholder-medium",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.assignmentData.user.initials
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                              _vm._v(" "),
                              _c("div", { staticClass: "user-info" }, [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.assignmentData.user.full_name)
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "user-role" }, [
                                  _vm._v(_vm._s(_vm.assignmentData.user.role)),
                                ]),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "assignment-stats" }, [
                            _c("div", { staticClass: "stat-item planned" }, [
                              _c("i", { staticClass: "fa fa-calendar" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "stat-content" }, [
                                _c("span", { staticClass: "stat-label" }, [
                                  _vm._v("Pianificate"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "stat-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.assignmentData.planned_hours) +
                                      "h"
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "stat-item actual" }, [
                              _c("i", { staticClass: "fa fa-check-circle" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "stat-content" }, [
                                _c("span", { staticClass: "stat-label" }, [
                                  _vm._v("Effettive"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "stat-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.assignmentData.actual_hours) +
                                      "h"
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "stat-item difference",
                                class: {
                                  positive:
                                    _vm.assignmentData.actual_hours >=
                                    _vm.assignmentData.planned_hours,
                                  negative:
                                    _vm.assignmentData.actual_hours <
                                    _vm.assignmentData.planned_hours,
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa",
                                  class:
                                    _vm.assignmentData.actual_hours >=
                                    _vm.assignmentData.planned_hours
                                      ? "fa-arrow-up"
                                      : "fa-arrow-down",
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "stat-content" }, [
                                  _c("span", { staticClass: "stat-label" }, [
                                    _vm._v("Differenza"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "stat-value" }, [
                                    _vm._v(
                                      _vm._s(
                                        Math.abs(
                                          _vm.assignmentData.actual_hours -
                                            _vm.assignmentData.planned_hours
                                        )
                                      ) + "h"
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "progress-bar-container" }, [
                            _c("div", {
                              staticClass: "progress-bar-fill",
                              style: {
                                width:
                                  Math.min(
                                    (_vm.assignmentData.actual_hours /
                                      _vm.assignmentData.planned_hours) *
                                      100,
                                    100
                                  ) + "%",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "progress-percentage" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  Math.round(
                                    (_vm.assignmentData.actual_hours /
                                      _vm.assignmentData.planned_hours) *
                                      100
                                  )
                                ) +
                                "% completato\n                    "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.assignmentData.actual_hours > 0 &&
                    _vm.assignmentData.description
                      ? _c(
                          "div",
                          { staticClass: "planning-description-readonly" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "description-readonly-content",
                              staticStyle: {
                                background: "#2a2a2a",
                                border: "1px solid #444",
                                "border-radius": "4px",
                                padding: "12px",
                                color: "#e0e0e0",
                                "font-size": "13px",
                                "line-height": "1.6",
                                "max-height": "300px",
                                "overflow-y": "auto",
                              },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.assignmentData.description
                                ),
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canModify
                      ? _c(
                          "div",
                          { staticClass: "edit-assignment-section" },
                          [
                            _vm.assignmentData.actual_hours > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "alert alert-warning",
                                    staticStyle: { margin: "0" },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-exclamation-triangle",
                                    }),
                                    _vm._v(
                                      "\n                        Non puoi modificare progetto/task per assegnazioni già iniziate (" +
                                        _vm._s(
                                          _vm.assignmentData.actual_hours
                                        ) +
                                        "h consuntivate)\n                    "
                                    ),
                                  ]
                                )
                              : [
                                  _c("h6", [
                                    _c("i", {
                                      staticClass: "fa",
                                      class: _vm.isCreationMode
                                        ? "fa-plus"
                                        : "fa-exchange",
                                    }),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.isCreationMode
                                            ? "Nuova Assegnazione"
                                            : "Modifica Assegnazione"
                                        ) +
                                        "\n                        "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "autocomplete-container" },
                                    [
                                      _c("label", [_vm._v("Progetto")]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { position: "relative" },
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.projectSearchQuery,
                                                expression:
                                                  "projectSearchQuery",
                                              },
                                            ],
                                            staticClass: "autocomplete-input",
                                            attrs: {
                                              type: "text",
                                              placeholder: "Cerca progetto...",
                                            },
                                            domProps: {
                                              value: _vm.projectSearchQuery,
                                            },
                                            on: {
                                              input: [
                                                function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.projectSearchQuery =
                                                    $event.target.value
                                                },
                                                _vm.filterProjects,
                                              ],
                                              focus: function ($event) {
                                                _vm.showProjectDropdown = true
                                              },
                                              blur: _vm.hideProjectDropdownDelayed,
                                              keydown: _vm.handleProjectKeydown,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _vm.editingAssignment.newProjectName
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-times autocomplete-clear",
                                                on: { click: _vm.clearProject },
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.showProjectDropdown &&
                                      _vm.projectSearchQuery.length >= 2
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "autocomplete-dropdown",
                                              on: {
                                                mousedown: function ($event) {
                                                  $event.preventDefault()
                                                },
                                              },
                                            },
                                            [
                                              _vm.isLoadingProjects
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "autocomplete-no-results",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-spinner fa-spin",
                                                      }),
                                                      _vm._v(
                                                        " Caricamento...\n                                "
                                                      ),
                                                    ]
                                                  )
                                                : _vm.filteredProjects
                                                    .length === 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "autocomplete-no-results",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                    Nessun progetto trovato\n                                "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._l(
                                                    _vm.filteredProjects,
                                                    function (project, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: project.id,
                                                          class: [
                                                            "autocomplete-item",
                                                            `autocomplete-item-project-${index}`,
                                                            {
                                                              "autocomplete-item-selected":
                                                                index ===
                                                                _vm.selectedProjectIndex,
                                                            },
                                                          ],
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.selectProject(
                                                                project
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                    " +
                                                              _vm._s(
                                                                project.title
                                                              ) +
                                                              " "
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color: "#888",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "(" +
                                                                  _vm._s(
                                                                    project.client_name
                                                                  ) +
                                                                  ")"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "autocomplete-container" },
                                    [
                                      _c("label", [_vm._v("Task (opzionale)")]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { position: "relative" },
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.subprojectSearchQuery,
                                                expression:
                                                  "subprojectSearchQuery",
                                              },
                                            ],
                                            staticClass: "autocomplete-input",
                                            attrs: {
                                              type: "text",
                                              placeholder: "Cerca task...",
                                              disabled:
                                                !_vm.editingAssignment
                                                  .newProjectId,
                                            },
                                            domProps: {
                                              value: _vm.subprojectSearchQuery,
                                            },
                                            on: {
                                              input: [
                                                function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.subprojectSearchQuery =
                                                    $event.target.value
                                                },
                                                _vm.filterSubprojects,
                                              ],
                                              focus: _vm.onSubprojectInputFocus,
                                              blur: _vm.handleMainSubprojectInputBlur,
                                              keydown:
                                                _vm.handleSubprojectKeydown,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _vm.editingAssignment
                                            .newSubprojectName
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-times autocomplete-clear",
                                                on: {
                                                  click: _vm.clearSubproject,
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.showSubprojectDropdown &&
                                      _vm.editingAssignment.newProjectId
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "autocomplete-dropdown",
                                              on: {
                                                mousedown: function ($event) {
                                                  $event.preventDefault()
                                                },
                                              },
                                            },
                                            [
                                              _vm.isLoadingSubprojects
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "autocomplete-no-results",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-spinner fa-spin",
                                                      }),
                                                      _vm._v(
                                                        " Caricamento...\n                                "
                                                      ),
                                                    ]
                                                  )
                                                : _vm.filteredSubprojects
                                                    .length === 0 &&
                                                  !_vm.subprojectSearchQuery
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "autocomplete-no-results",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                    Nessun task trovato\n                                "
                                                      ),
                                                    ]
                                                  )
                                                : [
                                                    _vm._l(
                                                      _vm.filteredSubprojects,
                                                      function (
                                                        subproject,
                                                        index
                                                      ) {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              key: subproject.id,
                                                              class: [
                                                                "autocomplete-item",
                                                                `autocomplete-item-subproject-${index}`,
                                                                {
                                                                  "autocomplete-item-selected":
                                                                    index ===
                                                                    _vm.selectedSubprojectIndex,
                                                                },
                                                              ],
                                                              style: {
                                                                paddingLeft:
                                                                  8 +
                                                                  (subproject.indent_level ||
                                                                    0) *
                                                                    20 +
                                                                  "px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                              },
                                                              on: {
                                                                mouseenter:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.selectedSubprojectIndex =
                                                                      index
                                                                  },
                                                                mouseleave:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.selectedSubprojectIndex =
                                                                      -1
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    flex: "1",
                                                                    cursor:
                                                                      "pointer",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.selectSubproject(
                                                                          subproject
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                " +
                                                                      _vm._s(
                                                                        subproject.name
                                                                      ) +
                                                                      "\n                                            "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.canModify &&
                                                              _vm.creatingSubtaskForParentId !==
                                                                subproject.id
                                                                ? _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "subtask-create-btn",
                                                                      staticStyle:
                                                                        {
                                                                          "margin-left":
                                                                            "auto",
                                                                          padding:
                                                                            "2px 6px",
                                                                          background:
                                                                            "#444",
                                                                          border:
                                                                            "none",
                                                                          color:
                                                                            "#fff",
                                                                          "border-radius":
                                                                            "3px",
                                                                          cursor:
                                                                            "pointer",
                                                                          "font-size":
                                                                            "12px",
                                                                          opacity:
                                                                            "0.7",
                                                                          transition:
                                                                            "opacity 0.2s",
                                                                        },
                                                                      attrs: {
                                                                        title:
                                                                          "Crea sottotask di " +
                                                                          subproject.name,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            return _vm.startCreatingSubtask(
                                                                              subproject.id
                                                                            )
                                                                          },
                                                                        mouseenter:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.target.style.opacity =
                                                                              "1"
                                                                          },
                                                                        mouseleave:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.target.style.opacity =
                                                                              "0.7"
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "fa fa-plus",
                                                                      }),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.creatingSubtaskForParentId ===
                                                          subproject.id
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  key:
                                                                    "subtask-input-" +
                                                                    subproject.id,
                                                                  staticClass:
                                                                    "subtask-create-input-container",
                                                                  style: {
                                                                    padding:
                                                                      "6px",
                                                                    paddingLeft:
                                                                      8 +
                                                                      ((subproject.indent_level ||
                                                                        0) +
                                                                        1) *
                                                                        20 +
                                                                      "px",
                                                                  },
                                                                  on: {
                                                                    mousedown:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.preventDefault()
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm.newSubtaskName,
                                                                          expression:
                                                                            "newSubtaskName",
                                                                        },
                                                                      ],
                                                                    ref: "subtaskInputRef",
                                                                    refInFor: true,
                                                                    staticClass:
                                                                      "subtask-create-input",
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                        padding:
                                                                          "6px 8px",
                                                                        background:
                                                                          "#333",
                                                                        border:
                                                                          "1px solid #555",
                                                                        color:
                                                                          "#fff",
                                                                        "border-radius":
                                                                          "3px",
                                                                        "font-size":
                                                                          "13px",
                                                                      },
                                                                    attrs: {
                                                                      placeholder:
                                                                        "Nome sottotask...",
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.newSubtaskName,
                                                                    },
                                                                    on: {
                                                                      keydown: [
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            !$event.type.indexOf(
                                                                              "key"
                                                                            ) &&
                                                                            _vm._k(
                                                                              $event.keyCode,
                                                                              "enter",
                                                                              13,
                                                                              $event.key,
                                                                              "Enter"
                                                                            )
                                                                          )
                                                                            return null
                                                                          $event.preventDefault()
                                                                          return _vm.createQuickSubtask(
                                                                            subproject.id
                                                                          )
                                                                        },
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            !$event.type.indexOf(
                                                                              "key"
                                                                            ) &&
                                                                            _vm._k(
                                                                              $event.keyCode,
                                                                              "escape",
                                                                              undefined,
                                                                              $event.key,
                                                                              undefined
                                                                            )
                                                                          )
                                                                            return null
                                                                          return _vm.cancelCreatingSubtask.apply(
                                                                            null,
                                                                            arguments
                                                                          )
                                                                        },
                                                                      ],
                                                                      mousedown:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          $event.preventDefault()
                                                                        },
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          $event.preventDefault()
                                                                        },
                                                                      focus:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          $event.preventDefault()
                                                                        },
                                                                      blur: _vm.handleSubtaskInputBlur,
                                                                      focusin:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          )
                                                                            return
                                                                          _vm.newSubtaskName =
                                                                            $event.target.value
                                                                        },
                                                                    },
                                                                  }),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      }
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.subprojectSearchQuery &&
                                                    _vm.subprojectSearchQuery
                                                      .length > 0 &&
                                                    _vm.filteredSubprojects
                                                      .length === 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "autocomplete-item autocomplete-item-create",
                                                            class: {
                                                              "autocomplete-item-selected":
                                                                _vm.selectedSubprojectIndex ===
                                                                  -1 &&
                                                                _vm
                                                                  .filteredSubprojects
                                                                  .length === 0,
                                                            },
                                                            staticStyle: {
                                                              "border-top":
                                                                "1px solid #444",
                                                              padding:
                                                                "10px 12px",
                                                              color: "#4CAF50",
                                                              "font-weight":
                                                                "500",
                                                              cursor: "pointer",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.createQuickTask()
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-plus-circle",
                                                            }),
                                                            _vm._v(
                                                              ' Crea nuovo task: "' +
                                                                _vm._s(
                                                                  _vm.subprojectSearchQuery
                                                                ) +
                                                                '"\n                                    '
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.subprojectSearchQuery &&
                                                    _vm.subprojectSearchQuery
                                                      .length > 0 &&
                                                    _vm.filteredSubprojects
                                                      .length > 0 &&
                                                    !_vm.isExactMatch(
                                                      _vm.subprojectSearchQuery
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "autocomplete-item autocomplete-item-create",
                                                            class: {
                                                              "autocomplete-item-selected":
                                                                _vm.selectedSubprojectIndex ===
                                                                _vm
                                                                  .filteredSubprojects
                                                                  .length,
                                                            },
                                                            staticStyle: {
                                                              "border-top":
                                                                "1px solid #444",
                                                              padding:
                                                                "10px 12px",
                                                              color: "#4CAF50",
                                                              "font-weight":
                                                                "500",
                                                              cursor: "pointer",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.createQuickTask()
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-plus-circle",
                                                            }),
                                                            _vm._v(
                                                              ' Crea nuovo task: "' +
                                                                _vm._s(
                                                                  _vm.subprojectSearchQuery
                                                                ) +
                                                                '"\n                                    '
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "autocomplete-container" },
                                    [
                                      _c("label", [_vm._v("Assegna a Utente")]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { position: "relative" },
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.userSearchQuery,
                                                expression: "userSearchQuery",
                                              },
                                            ],
                                            staticClass: "autocomplete-input",
                                            attrs: {
                                              type: "text",
                                              placeholder: "Cerca utente...",
                                            },
                                            domProps: {
                                              value: _vm.userSearchQuery,
                                            },
                                            on: {
                                              input: [
                                                function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.userSearchQuery =
                                                    $event.target.value
                                                },
                                                _vm.filterUsers,
                                              ],
                                              focus: _vm.onUserInputFocus,
                                              blur: _vm.hideUserDropdownDelayed,
                                              keydown: _vm.handleUserKeydown,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _vm.editingAssignment.newUserName
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-times autocomplete-clear",
                                                on: { click: _vm.clearUser },
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.showUserDropdown
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "autocomplete-dropdown",
                                              on: {
                                                mousedown: function ($event) {
                                                  $event.preventDefault()
                                                },
                                              },
                                            },
                                            [
                                              _vm.filteredUsers.length === 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "autocomplete-no-results",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                    Nessun utente trovato\n                                "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._l(
                                                    _vm.filteredUsers,
                                                    function (user, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: user.id,
                                                          class: [
                                                            "autocomplete-item",
                                                            `autocomplete-item-user-${index}`,
                                                            {
                                                              "autocomplete-item-selected":
                                                                index ===
                                                                _vm.selectedUserIndex,
                                                            },
                                                          ],
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.selectUser(
                                                                user
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                    " +
                                                              _vm._s(
                                                                user.full_name
                                                              ) +
                                                              " "
                                                          ),
                                                          user.division
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#888",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "(" +
                                                                      _vm._s(
                                                                        user.division
                                                                      ) +
                                                                      ")"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      staticStyle: { "margin-bottom": "15px" },
                                    },
                                    [
                                      _c("label", [
                                        _vm._v("Nuove Ore Pianificate *"),
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model.number",
                                            value:
                                              _vm.editingAssignment.newHours,
                                            expression:
                                              "editingAssignment.newHours",
                                            modifiers: { number: true },
                                          },
                                        ],
                                        staticClass: "form-control",
                                        staticStyle: {
                                          background: "#2a2a2a",
                                          border: "1px solid #444",
                                          color: "#e0e0e0",
                                        },
                                        attrs: {
                                          type: "number",
                                          min: "0.5",
                                          step: "0.5",
                                          placeholder: "Inserisci ore...",
                                        },
                                        domProps: {
                                          value: _vm.editingAssignment.newHours,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.editingAssignment,
                                              "newHours",
                                              _vm._n($event.target.value)
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.$forceUpdate()
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      staticStyle: { "margin-bottom": "15px" },
                                    },
                                    [
                                      _c("label", [_vm._v("Descrizione")]),
                                      _vm._v(" "),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.editingAssignment
                                                .newDescription,
                                            expression:
                                              "editingAssignment.newDescription",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        staticStyle: {
                                          background: "#2a2a2a",
                                          border: "1px solid #444",
                                          color: "#e0e0e0",
                                        },
                                        attrs: {
                                          rows: "4",
                                          placeholder:
                                            "Note o descrizione dell'assegnazione (opzionale)...",
                                        },
                                        domProps: {
                                          value:
                                            _vm.editingAssignment
                                              .newDescription,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.editingAssignment,
                                              "newDescription",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group",
                                      staticStyle: { "margin-bottom": "15px" },
                                    },
                                    [
                                      _c("label", [
                                        _vm._v("Data specifica (opzionale)"),
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        ref: "taskSidebarSpecificDateInput",
                                        staticClass: "form-control date-picker",
                                        staticStyle: {
                                          background: "#2a2a2a",
                                          border: "1px solid #444",
                                          color: "#e0e0e0",
                                        },
                                        attrs: {
                                          type: "text",
                                          "data-field":
                                            "task_sidebar_specific_date_hidden",
                                          placeholder: "Seleziona data",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        attrs: {
                                          type: "hidden",
                                          id: "task_sidebar_specific_date_hidden",
                                        },
                                        domProps: {
                                          value:
                                            _vm.editingAssignment.specificDate,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        {
                                          staticStyle: {
                                            display: "block",
                                            "margin-top": "5px",
                                            color: "#888",
                                            "font-size": "12px",
                                          },
                                        },
                                        [
                                          _vm.isCreationMode
                                            ? [
                                                _vm._v(
                                                  "\n                                    Lascia vuoto per associare il task all'intera settimana, oppure seleziona un giorno nella settimana in cui stai creando l'assegnazione.\n                                "
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                    Lascia vuoto per associare il task all'intera settimana, oppure scegli un giorno specifico (anche in una settimana successiva).\n                                "
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-warning btn-sm",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        type: "button",
                                        disabled:
                                          _vm.isSavingAssignment ||
                                          !_vm.isAssignmentValid,
                                      },
                                      on: {
                                        click: _vm.confirmAssignmentChange,
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa",
                                        class: _vm.isSavingAssignment
                                          ? "fa-spinner fa-spin"
                                          : _vm.isCreationMode
                                          ? "fa-plus"
                                          : "fa-check",
                                      }),
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.isSavingAssignment
                                              ? "Salvataggio..."
                                              : _vm.isCreationMode
                                              ? "Crea Assegnazione"
                                              : "Applica Modifica"
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.subprojectId
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab === "overview",
                        expression: "activeTab === 'overview'",
                      },
                    ],
                    staticClass: "tab-content overview-tab",
                  },
                  [
                    _vm.taskData.expected_duration ||
                    _vm.taskData.planned_hours ||
                    _vm.taskData.total_hours
                      ? _c("div", { staticClass: "task-kpi-block" }, [
                          _c("div", { staticClass: "kpi-stats" }, [
                            _vm.taskData.expected_duration &&
                            _vm.taskData.expected_duration > 0
                              ? _c(
                                  "div",
                                  { staticClass: "kpi-item estimated" },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-file-text-o",
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "kpi-content" }, [
                                      _c("span", { staticClass: "kpi-label" }, [
                                        _vm._v("Preventivate"),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "kpi-value" }, [
                                        _vm._v(
                                          _vm._s(
                                            Math.round(
                                              _vm.taskData.expected_duration
                                            )
                                          ) + "h"
                                        ),
                                      ]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "kpi-item planned" }, [
                              _c("i", { staticClass: "fa fa-calendar" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "kpi-content" }, [
                                _c("span", { staticClass: "kpi-label" }, [
                                  _vm._v("Pianificate"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "kpi-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      Math.round(
                                        _vm.taskData.planned_hours || 0
                                      )
                                    ) + "h"
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "kpi-item actual" }, [
                              _c("i", { staticClass: "fa fa-check-circle" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "kpi-content" }, [
                                _c("span", { staticClass: "kpi-label" }, [
                                  _vm._v("Effettive"),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "kpi-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      Math.round(_vm.taskData.total_hours || 0)
                                    ) + "h"
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.taskData.expected_duration &&
                            _vm.taskData.expected_duration > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "kpi-item difference",
                                    class: {
                                      positive:
                                        _vm.taskData.expected_duration -
                                          ((_vm.taskData.planned_hours || 0) +
                                            (_vm.taskData.total_hours || 0)) >=
                                        0,
                                      negative:
                                        _vm.taskData.expected_duration -
                                          ((_vm.taskData.planned_hours || 0) +
                                            (_vm.taskData.total_hours || 0)) <
                                        0,
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa",
                                      class:
                                        _vm.taskData.expected_duration -
                                          ((_vm.taskData.planned_hours || 0) +
                                            (_vm.taskData.total_hours || 0)) >=
                                        0
                                          ? "fa-arrow-up"
                                          : "fa-arrow-down",
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "kpi-content" }, [
                                      _c("span", { staticClass: "kpi-label" }, [
                                        _vm._v("Differenza"),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "kpi-value" }, [
                                        _vm._v(
                                          _vm._s(
                                            Math.round(
                                              Math.abs(
                                                _vm.taskData.expected_duration -
                                                  ((_vm.taskData
                                                    .planned_hours || 0) +
                                                    (_vm.taskData.total_hours ||
                                                      0))
                                              )
                                            )
                                          ) + "h"
                                        ),
                                      ]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _vm.taskData.expected_duration &&
                          _vm.taskData.expected_duration > 0
                            ? _c(
                                "div",
                                { staticClass: "kpi-progress-container" },
                                [
                                  _c("div", {
                                    staticClass: "kpi-progress-bar-fill",
                                    style: {
                                      width:
                                        Math.min(
                                          ((_vm.taskData.total_hours || 0) /
                                            _vm.taskData.expected_duration) *
                                            100,
                                          100
                                        ) + "%",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "task-info-row" }, [
                      (_vm.canModify &&
                        !_vm.isPlanningMode &&
                        !_vm.taskData.has_children) ||
                      _vm.taskData.expected_duration
                        ? _c("div", { staticClass: "info-item-inline" }, [
                            _c("i", { staticClass: "fa fa-hourglass-half" }),
                            _vm._v(" "),
                            _vm.canModify &&
                            !_vm.isPlanningMode &&
                            !_vm.taskData.has_children
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "info-value editable",
                                    attrs: {
                                      contenteditable: "true",
                                      "data-placeholder": !_vm.taskData
                                        .expected_duration
                                        ? "-"
                                        : "",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.handleFieldInput(
                                          "expected_duration",
                                          $event
                                        )
                                      },
                                      blur: function ($event) {
                                        return _vm.saveField(
                                          "expected_duration"
                                        )
                                      },
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        $event.preventDefault()
                                        return $event.target.blur()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.taskData.expected_duration || ""
                                      )
                                    ),
                                  ]
                                )
                              : _c("span", { staticClass: "info-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.taskData.expected_duration) + "h"
                                  ),
                                ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.canModify &&
                        !_vm.isPlanningMode &&
                        !_vm.taskData.has_children) ||
                      _vm.taskData.start_date
                        ? _c(
                            "div",
                            { staticClass: "info-item-inline" },
                            [
                              _c("i", { staticClass: "fa fa-calendar" }),
                              _vm._v(" "),
                              _vm.canModify &&
                              !_vm.isPlanningMode &&
                              !_vm.taskData.has_children
                                ? [
                                    _vm.isEditingStartDate ||
                                    _vm.editingFields.start_date
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.editingFields.start_date,
                                              expression:
                                                "editingFields.start_date",
                                            },
                                          ],
                                          ref: "startDateInput",
                                          staticClass: "inline-date-input",
                                          attrs: { type: "date" },
                                          domProps: {
                                            value: _vm.editingFields.start_date,
                                          },
                                          on: {
                                            change: _vm.saveStartDate,
                                            blur: function ($event) {
                                              _vm.isEditingStartDate = false
                                            },
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.editingFields,
                                                "start_date",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        })
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "info-value editable-placeholder",
                                            attrs: { title: "Data inizio" },
                                            on: {
                                              click: _vm.startEditingStartDate,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.taskData.start_date ||
                                                    "Inizio"
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                  ]
                                : _c("span", { staticClass: "info-value" }, [
                                    _vm._v(_vm._s(_vm.taskData.start_date)),
                                  ]),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.canModify &&
                        !_vm.isPlanningMode &&
                        !_vm.taskData.has_children) ||
                      _vm.taskData.end_date
                        ? _c(
                            "div",
                            { staticClass: "info-item-inline" },
                            [
                              _c("i", {
                                staticClass: "fa fa-calendar-check-o",
                              }),
                              _vm._v(" "),
                              _vm.canModify &&
                              !_vm.isPlanningMode &&
                              !_vm.taskData.has_children
                                ? [
                                    _vm.isEditingEndDate ||
                                    _vm.editingFields.end_date
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.editingFields.end_date,
                                              expression:
                                                "editingFields.end_date",
                                            },
                                          ],
                                          ref: "endDateInput",
                                          staticClass: "inline-date-input",
                                          attrs: { type: "date" },
                                          domProps: {
                                            value: _vm.editingFields.end_date,
                                          },
                                          on: {
                                            change: _vm.saveEndDate,
                                            blur: function ($event) {
                                              _vm.isEditingEndDate = false
                                            },
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.editingFields,
                                                "end_date",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        })
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "info-value editable-placeholder",
                                            class: {
                                              "text-muted":
                                                !_vm.taskData.end_date &&
                                                _vm.taskData.suggested_end_date,
                                            },
                                            attrs: { title: "Data fine" },
                                            on: {
                                              click: _vm.startEditingEndDate,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.taskData.end_date ||
                                                    (_vm.taskData
                                                      .suggested_end_date
                                                      ? "~" +
                                                        _vm.taskData
                                                          .suggested_end_date
                                                      : "Fine")
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                  ]
                                : _c("span", { staticClass: "info-value" }, [
                                    _vm._v(_vm._s(_vm.taskData.end_date)),
                                  ]),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.canModify && !_vm.isPlanningMode) ||
                      _vm.taskData.due_date
                        ? _c(
                            "div",
                            { staticClass: "info-item-inline" },
                            [
                              _c("i", { staticClass: "fa fa-clock-o" }),
                              _vm._v(" "),
                              _vm.canModify && !_vm.isPlanningMode
                                ? [
                                    _vm.isEditingDueDate ||
                                    _vm.editingFields.due_date
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.editingFields.due_date,
                                              expression:
                                                "editingFields.due_date",
                                            },
                                          ],
                                          ref: "dueDateInput",
                                          staticClass: "inline-date-input",
                                          attrs: { type: "date" },
                                          domProps: {
                                            value: _vm.editingFields.due_date,
                                          },
                                          on: {
                                            change: _vm.saveDueDate,
                                            blur: function ($event) {
                                              _vm.isEditingDueDate = false
                                            },
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.editingFields,
                                                "due_date",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        })
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "info-value editable-placeholder",
                                            on: {
                                              click: _vm.startEditingDueDate,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.taskData.due_date ||
                                                    "--/--"
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                  ]
                                : _c("span", { staticClass: "info-value" }, [
                                    _vm._v(
                                      _vm._s(_vm.taskData.due_date || "--/--")
                                    ),
                                  ]),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.canModify && !_vm.isPlanningMode) ||
                      _vm.taskData.commercial_agreement
                        ? _c("div", { staticClass: "info-item-inline" }, [
                            _c("i", { staticClass: "fa fa-tag" }),
                            _vm._v(" "),
                            _vm.canModify && !_vm.isPlanningMode
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "info-value editable clickable",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.openTypeSelector.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.editingFields
                                            .commercial_agreement ||
                                            _vm.taskData.commercial_agreement ||
                                            "-"
                                        ) +
                                        "\n                            "
                                    ),
                                    _c("i", {
                                      staticClass: "fa fa-caret-down",
                                      staticStyle: { "font-size": "10px" },
                                    }),
                                  ]
                                )
                              : _c("span", { staticClass: "info-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.taskData.commercial_agreement)
                                  ),
                                ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.canModify && !_vm.isPlanningMode) ||
                      _vm.taskData.priority
                        ? _c("div", { staticClass: "info-item-inline" }, [
                            _c("i", { staticClass: "fa fa-flag" }),
                            _vm._v(" "),
                            _vm.canModify && !_vm.isPlanningMode
                              ? _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editingFields.priority,
                                        expression: "editingFields.priority",
                                      },
                                    ],
                                    staticClass: "inline-priority-select",
                                    class:
                                      "priority-" +
                                      (_vm.editingFields.priority ||
                                        _vm.taskData.priority),
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.editingFields,
                                            "priority",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                        _vm.savePriority,
                                      ],
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "low" } }, [
                                      _vm._v("Bassa"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "medium" } },
                                      [_vm._v("Media")]
                                    ),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "high" } }, [
                                      _vm._v("Alta"),
                                    ]),
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "info-value",
                                    class:
                                      "priority-text-" + _vm.taskData.priority,
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.priorityLabel(
                                            _vm.taskData.priority
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.taskData.show_task_sheet_field &&
                      ((_vm.canModify && !_vm.isPlanningMode) ||
                        _vm.taskData.task_sheet_id)
                        ? _c("div", { staticClass: "info-item-inline" }, [
                            _c("i", { staticClass: "fa fa-folder-open-o" }),
                            _vm._v(" "),
                            _vm.canModify && !_vm.isPlanningMode
                              ? _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editingFields.task_sheet_id,
                                        expression:
                                          "editingFields.task_sheet_id",
                                      },
                                    ],
                                    staticClass: "inline-priority-select",
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.editingFields,
                                            "task_sheet_id",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                        _vm.saveTaskSheet,
                                      ],
                                    },
                                  },
                                  [
                                    _c(
                                      "option",
                                      { domProps: { value: null } },
                                      [_vm._v("Nessun foglio")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.taskData.task_sheets,
                                      function (sheet) {
                                        return _c(
                                          "option",
                                          {
                                            key: sheet.id,
                                            domProps: { value: sheet.id },
                                          },
                                          [_vm._v(_vm._s(sheet.name))]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _c("span", { staticClass: "info-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.taskSheetLabel(
                                        _vm.taskData.task_sheet_id
                                      )
                                    )
                                  ),
                                ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.canModify && !_vm.isPlanningMode) ||
                      (_vm.taskData.assigned_users &&
                        _vm.taskData.assigned_users.length > 0)
                        ? _c("div", { staticClass: "info-separator" })
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.canModify && !_vm.isPlanningMode) ||
                      (_vm.taskData.assigned_users &&
                        _vm.taskData.assigned_users.length > 0)
                        ? _c(
                            "div",
                            { staticClass: "assigned-users-inline-compact" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "assigned-label",
                                  class: {
                                    clickable:
                                      _vm.canModify && !_vm.isPlanningMode,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.canModify &&
                                        !_vm.isPlanningMode &&
                                        _vm.openAssigneeSelector()
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fa fa-users" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "users-avatars-inline" },
                                [
                                  _vm._l(
                                    _vm.taskData.assigned_users,
                                    function (user) {
                                      return _c(
                                        "div",
                                        {
                                          key: user.id,
                                          staticClass: "user-avatar-wrapper",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "user-avatar-small",
                                              attrs: { title: user.full_name },
                                            },
                                            [
                                              user.avatar
                                                ? _c("img", {
                                                    attrs: {
                                                      src: user.avatar,
                                                      alt: user.full_name,
                                                    },
                                                  })
                                                : _c(
                                                    "span",
                                                    { staticClass: "initials" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(user.initials)
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.canModify && !_vm.isPlanningMode
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "user-remove-btn",
                                                  attrs: { title: "Rimuovi" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.removeAssignee(
                                                        user.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("×")]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm.canModify && !_vm.isPlanningMode
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "user-avatar-small add-btn",
                                          attrs: { title: "Aggiungi" },
                                          on: {
                                            click: _vm.openAssigneeSelector,
                                          },
                                        },
                                        [_c("i", { staticClass: "fa fa-plus" })]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.canModify ||
                    (_vm.taskData.predecessors &&
                      _vm.taskData.predecessors.length) ||
                    (_vm.taskData.successors && _vm.taskData.successors.length)
                      ? _c("div", { staticClass: "dependencies-section" }, [
                          _vm._m(2),
                          _vm._v(" "),
                          _vm.taskData.predecessors &&
                          _vm.taskData.predecessors.length
                            ? _c(
                                "div",
                                { staticClass: "dep-list" },
                                _vm._l(
                                  _vm.taskData.predecessors,
                                  function (pred) {
                                    return _c(
                                      "div",
                                      {
                                        key: "pred-" + pred.id,
                                        staticClass: "dep-item",
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-arrow-left dep-icon pred",
                                        }),
                                        _vm._v(" "),
                                        pred.code
                                          ? _c(
                                              "span",
                                              { staticClass: "dep-code" },
                                              [_vm._v(_vm._s(pred.code))]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "dep-name" },
                                          [_vm._v(_vm._s(pred.name))]
                                        ),
                                        _vm._v(" "),
                                        _vm.canModify && !_vm.isPlanningMode
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "dep-remove",
                                                attrs: {
                                                  title: "Rimuovi dipendenza",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.removeDependency(
                                                      pred.pivot_id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-times",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.taskData.successors &&
                          _vm.taskData.successors.length
                            ? _c(
                                "div",
                                { staticClass: "dep-list" },
                                _vm._l(
                                  _vm.taskData.successors,
                                  function (succ) {
                                    return _c(
                                      "div",
                                      {
                                        key: "succ-" + succ.id,
                                        staticClass: "dep-item",
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-arrow-right dep-icon succ",
                                        }),
                                        _vm._v(" "),
                                        succ.code
                                          ? _c(
                                              "span",
                                              { staticClass: "dep-code" },
                                              [_vm._v(_vm._s(succ.code))]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "dep-name" },
                                          [_vm._v(_vm._s(succ.name))]
                                        ),
                                        _vm._v(" "),
                                        _vm.canModify && !_vm.isPlanningMode
                                          ? _c(
                                              "button",
                                              {
                                                staticClass: "dep-remove",
                                                attrs: {
                                                  title: "Rimuovi dipendenza",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.removeDependency(
                                                      succ.pivot_id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-times",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canModify && !_vm.isPlanningMode
                            ? _c("div", { staticClass: "dep-add" }, [
                                !_vm.isAddingDep
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "dep-add-trigger",
                                        on: {
                                          click: function ($event) {
                                            _vm.isAddingDep = true
                                          },
                                        },
                                      },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(
                                          " Aggiungi predecessore\n                        "
                                        ),
                                      ]
                                    )
                                  : _c("div", { staticClass: "dep-add-form" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.depSearchQuery,
                                            expression: "depSearchQuery",
                                          },
                                        ],
                                        ref: "depSearchInput",
                                        staticClass: "dep-search-input",
                                        attrs: {
                                          type: "text",
                                          placeholder: "Cerca task...",
                                        },
                                        domProps: { value: _vm.depSearchQuery },
                                        on: {
                                          input: [
                                            function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.depSearchQuery =
                                                $event.target.value
                                            },
                                            _vm.searchDependencyTasks,
                                          ],
                                          blur: _vm.closeDepSearch,
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "escape",
                                                undefined,
                                                $event.key,
                                                undefined
                                              )
                                            )
                                              return null
                                            _vm.isAddingDep = false
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.depSearchResults.length
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "dep-search-results",
                                            },
                                            _vm._l(
                                              _vm.depSearchResults,
                                              function (result) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: result.id,
                                                    staticClass:
                                                      "dep-search-item",
                                                    on: {
                                                      mousedown: function (
                                                        $event
                                                      ) {
                                                        $event.preventDefault()
                                                        return _vm.addDependency(
                                                          result.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    result.code
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "dep-code",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                result.code
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(result.name) +
                                                        "\n                                "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.taskData.predecessors.length &&
                          !_vm.taskData.successors.length &&
                          !(_vm.canModify && !_vm.isPlanningMode)
                            ? _c("div", { staticClass: "dep-empty" }, [
                                _vm._v(
                                  "\n                        Nessuna dipendenza\n                    "
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.taskData.creator
                      ? _c("div", { staticClass: "task-created-info" }, [
                          _c("i", { staticClass: "fa fa-user-o" }),
                          _vm._v(" Creato da "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.taskData.creator.full_name)),
                          ]),
                          _vm._v(
                            " il " +
                              _vm._s(_vm.taskData.created_at) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "description-section",
                        on: {
                          dragover: function ($event) {
                            $event.preventDefault()
                            return _vm.handleDescriptionAreaDragover.apply(
                              null,
                              arguments
                            )
                          },
                          dragleave: function ($event) {
                            $event.preventDefault()
                            return _vm.handleDescriptionAreaDragleave.apply(
                              null,
                              arguments
                            )
                          },
                          drop: function ($event) {
                            $event.preventDefault()
                            return _vm.handleDescriptionDrop.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        !_vm.isEditingDescription
                          ? _c("div", {
                              staticClass: "description-view",
                              class: {
                                "is-empty": !_vm.descriptionText,
                                "is-dragover": _vm.descriptionDragover,
                              },
                              domProps: {
                                innerHTML: _vm._s(_vm.descriptionHtml || ""),
                              },
                              on: { click: _vm.handleDescriptionViewClick },
                            })
                          : [
                              _c("wysiwyg-editor", {
                                ref: "descriptionEditor",
                                attrs: {
                                  users: _vm.projectUsers,
                                  attachments: _vm.attachments,
                                  disabled: !_vm.canModify,
                                  "task-id": _vm.subprojectId,
                                  mode: "description",
                                  placeholder: "Aggiungi una descrizione...",
                                },
                                on: {
                                  blur: _vm.handleDescriptionBlurWysiwyg,
                                  "image-uploaded":
                                    _vm.handleDescriptionImageUploaded,
                                  "file-uploaded":
                                    _vm.handleDescriptionFileUploaded,
                                  "file-pasted":
                                    _vm.handleDescriptionFilePasted,
                                  "preview-image": _vm.openImagePreview,
                                  "upload-error": _vm.showError,
                                },
                                model: {
                                  value: _vm.descriptionText,
                                  callback: function ($$v) {
                                    _vm.descriptionText = $$v
                                  },
                                  expression: "descriptionText",
                                },
                              }),
                            ],
                        _vm._v(" "),
                        _vm.isSavingDescription
                          ? _c(
                              "div",
                              { staticClass: "description-saving-indicator" },
                              [
                                _c("i", {
                                  staticClass: "fa fa-spinner fa-spin",
                                }),
                                _vm._v(" Salvataggio...\n                    "),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.descriptionGalleryAttachments.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "description-attachments-gallery",
                              },
                              _vm._l(
                                _vm.descriptionGalleryAttachments,
                                function (attachment) {
                                  return _c(
                                    "div",
                                    {
                                      key: attachment.id,
                                      staticClass: "gallery-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleGalleryItemClick(
                                            attachment
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.isImageAttachment(attachment)
                                        ? _c(
                                            "div",
                                            { staticClass: "gallery-thumb" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: attachment.download_url,
                                                  alt: attachment.file_name,
                                                  loading: "lazy",
                                                },
                                              }),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "gallery-file-icon",
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa",
                                                class: attachment.icon,
                                              }),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "gallery-item-name" },
                                        [_vm._v(_vm._s(attachment.file_name))]
                                      ),
                                      _vm._v(" "),
                                      _vm.canModify
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "gallery-item-delete",
                                              attrs: {
                                                type: "button",
                                                title: "Elimina",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.deleteAttachment(
                                                    attachment.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-times",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.descriptionDragover
                          ? _c(
                              "div",
                              { staticClass: "description-drop-overlay" },
                              [
                                _c("i", { staticClass: "fa fa-cloud-upload" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Rilascia per allegare")]),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "chat-section" }, [
                      _c("h5", { staticClass: "section-title" }, [
                        _c("i", { staticClass: "fa fa-comments" }),
                        _vm._v(
                          " Discussione (" +
                            _vm._s(_vm.comments.length) +
                            ")\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "activity-filter" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-xs",
                            class:
                              _vm.activityFilter === "comments"
                                ? "btn-primary"
                                : "btn-default",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.activityFilter = "comments"
                              },
                            },
                          },
                          [_vm._v("Commenti")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-xs",
                            class:
                              _vm.activityFilter === "all"
                                ? "btn-primary"
                                : "btn-default",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.activityFilter = "all"
                              },
                            },
                          },
                          [_vm._v("Tutta l'attività")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { ref: "commentsList", staticClass: "comments-list" },
                        [
                          _vm.discussionEntries.length === 0
                            ? _c("div", { staticClass: "empty-state-small" }, [
                                _c("i", { staticClass: "fa fa-comments-o" }),
                                _vm._v(" "),
                                _c("p", [_vm._v("Inizia la discussione")]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.discussionEntries, function (entry) {
                            return _c("div", { key: entry.key }, [
                              entry.kind === "activity"
                                ? _c("div", { staticClass: "activity-item" }, [
                                    _c("i", { staticClass: "fa fa-history" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(entry.activity.user_name)
                                        ),
                                      ]),
                                      _vm._v(
                                        " " + _vm._s(entry.activity.summary)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "comment-time" },
                                      [
                                        _vm._v(
                                          _vm._s(entry.activity.created_at)
                                        ),
                                      ]
                                    ),
                                  ])
                                : _c(
                                    "div",
                                    {
                                      staticClass: "comment-item",
                                      class: {
                                        "is-own": entry.comment.is_own,
                                        "is-editing":
                                          _vm.editingCommentId ===
                                          entry.comment.id,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "comment-avatar" },
                                        [
                                          entry.comment.user.avatar
                                            ? _c("img", {
                                                attrs: {
                                                  src: entry.comment.user
                                                    .avatar,
                                                  alt: entry.comment.user
                                                    .full_name,
                                                },
                                              })
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "avatar-placeholder",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        entry.comment.user.full_name.charAt(
                                                          0
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "comment-content" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "comment-header" },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    entry.comment.user.full_name
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "comment-time" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      entry.comment.created_at
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              entry.comment.updated_at &&
                                              entry.comment.updated_at !==
                                                entry.comment.created_at
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "comment-edited",
                                                    },
                                                    [_vm._v("(modificato)")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.editingCommentId !==
                                          entry.comment.id
                                            ? _c("div", {
                                                staticClass: "comment-text",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    entry.comment
                                                      .formatted_comment
                                                  ),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleCommentImageClick(
                                                      $event
                                                    )
                                                  },
                                                },
                                              })
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "comment-edit-form",
                                                },
                                                [
                                                  _c("wysiwyg-editor", {
                                                    key:
                                                      "edit-comment-" +
                                                      _vm.editingCommentId,
                                                    ref: "editCommentEditor",
                                                    refInFor: true,
                                                    attrs: {
                                                      users: _vm.projectUsers,
                                                      attachments:
                                                        _vm.attachments,
                                                      "task-id":
                                                        _vm.subprojectId,
                                                      "initial-mentioned-user-ids":
                                                        _vm.editingCommentBaselineMentions,
                                                      mode: "comment",
                                                      placeholder:
                                                        "Modifica commento...",
                                                    },
                                                    on: {
                                                      mentioned:
                                                        _vm.handleEditMention,
                                                      "file-uploaded":
                                                        _vm.handleDescriptionFileUploaded,
                                                      "image-uploaded":
                                                        _vm.handleDescriptionFileUploaded,
                                                      submit: function (
                                                        $event
                                                      ) {
                                                        return _vm.saveEditComment(
                                                          entry.comment.id
                                                        )
                                                      },
                                                      "preview-image":
                                                        _vm.openImagePreview,
                                                      "upload-error":
                                                        _vm.showError,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.editingCommentText,
                                                      callback: function ($$v) {
                                                        _vm.editingCommentText =
                                                          $$v
                                                      },
                                                      expression:
                                                        "editingCommentText",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "comment-edit-actions",
                                                    },
                                                    [
                                                      _vm.isSavingComment
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "comment-autosave-indicator",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-spinner fa-spin",
                                                              }),
                                                              _vm._v(
                                                                " Salvataggio...\n                                        "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-sm btn-secondary",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.cancelEditComment,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            Annulla\n                                        "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-sm btn-primary",
                                                          attrs: {
                                                            type: "button",
                                                            disabled:
                                                              _vm.isEditCommentEmpty ||
                                                              _vm.isSavingComment,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.saveEditComment(
                                                                entry.comment.id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm.isSavingComment
                                                            ? _c("i", {
                                                                staticClass:
                                                                  "fa fa-spinner fa-spin",
                                                              })
                                                            : _c("span", [
                                                                _vm._v("Salva"),
                                                              ]),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                          _vm._v(" "),
                                          _vm.editingCommentId !==
                                          entry.comment.id
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "comment-footer",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "comment-reactions",
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn-reaction",
                                                          class: {
                                                            "is-reacted":
                                                              entry.comment
                                                                .has_reacted,
                                                          },
                                                          attrs: {
                                                            type: "button",
                                                            disabled:
                                                              entry.comment
                                                                ._reactingInProgress,
                                                            title:
                                                              _vm.reactionTooltip(
                                                                entry.comment
                                                              ),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.toggleReaction(
                                                                entry.comment
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-thumbs-up",
                                                          }),
                                                          _vm._v(" "),
                                                          entry.comment
                                                            .reactions_count > 0
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "reaction-count",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      entry
                                                                        .comment
                                                                        .reactions_count
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  entry.comment.is_own
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "comment-actions",
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn-edit-comment",
                                                              attrs: {
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.startEditComment(
                                                                      entry.comment
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-pencil",
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn-delete-comment",
                                                              attrs: {
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.deleteComment(
                                                                      entry
                                                                        .comment
                                                                        .id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-trash",
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                            ])
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === "timesheet",
                    expression: "activeTab === 'timesheet'",
                  },
                ],
                staticClass: "tab-content",
              },
              [
                _c("div", { staticClass: "timesheet-section" }, [
                  _vm.weekStart && _vm.weekEnd
                    ? _c("div", { staticClass: "week-indicator" }, [
                        _c("i", { staticClass: "fa fa-calendar-check-o" }),
                        _vm._v(
                          "\n                        Settimana: " +
                            _vm._s(_vm.formatWeekDisplay(_vm.weekStart)) +
                            " - " +
                            _vm._s(_vm.formatWeekDisplay(_vm.weekEnd)) +
                            "\n                    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLoadingTimesheet
                    ? _c("div", { staticClass: "loading-indicator" }, [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(
                          " Caricamento timesheet...\n                    "
                        ),
                      ])
                    : _vm.timesheetEntries.length === 0
                    ? _c("div", { staticClass: "empty-state" }, [
                        _c("i", { staticClass: "fa fa-clock-o" }),
                        _vm._v(" "),
                        _vm.weekStart && _vm.weekEnd
                          ? _c("p", [
                              _vm._v(
                                "Nessun timesheet registrato per questa settimana"
                              ),
                            ])
                          : _c("p", [_vm._v("Nessun timesheet registrato")]),
                      ])
                    : _c(
                        "div",
                        { staticClass: "timesheet-list" },
                        _vm._l(_vm.timesheetEntries, function (entry) {
                          return _c(
                            "div",
                            { key: entry.id, staticClass: "timesheet-item" },
                            [
                              _c(
                                "div",
                                { staticClass: "timesheet-header-row" },
                                [
                                  _c("div", { staticClass: "timesheet-date" }, [
                                    _c("i", { staticClass: "fa fa-calendar" }),
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(entry.formatted_date) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "timesheet-user" }, [
                                    _c("i", { staticClass: "fa fa-user" }),
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(entry.user.full_name) +
                                        "\n                                "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              entry.task_name
                                ? _c(
                                    "div",
                                    { staticClass: "timesheet-task-name" },
                                    [
                                      _c("i", { staticClass: "fa fa-tag" }),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(entry.task_name) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "timesheet-content" }, [
                                _c(
                                  "div",
                                  { staticClass: "timesheet-description" },
                                  [_vm._v(_vm._s(entry.description))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "timesheet-duration" },
                                  [
                                    _c("i", { staticClass: "fa fa-clock-o" }),
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(entry.formatted_duration) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.subprojectId
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab === "attachments",
                        expression: "activeTab === 'attachments'",
                      },
                    ],
                    staticClass: "tab-content",
                  },
                  [
                    _c("div", { staticClass: "attachments-section" }, [
                      _vm.canModify
                        ? _c(
                            "div",
                            {
                              staticClass: "dropzone",
                              class: { "is-dragover": _vm.isDragover },
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.fileInput.click()
                                },
                                dragover: function ($event) {
                                  $event.preventDefault()
                                  _vm.isDragover = true
                                },
                                dragleave: function ($event) {
                                  $event.preventDefault()
                                  _vm.isDragover = false
                                },
                                drop: function ($event) {
                                  $event.preventDefault()
                                  return _vm.handleFileDrop.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-cloud-upload" }),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "Trascina uno o più file qui o clicca per selezionare"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("small", [
                                _vm._v(
                                  "Max 50MB per file - documenti, immagini, archivi, testo"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                ref: "fileInput",
                                staticStyle: { display: "none" },
                                attrs: {
                                  type: "file",
                                  multiple: "",
                                  accept:
                                    ".pdf,.doc,.docx,.odt,.rtf,.xls,.xlsx,.ods,.csv,.tsv,.ppt,.pptx,.odp,.jpg,.jpeg,.png,.gif,.webp,.svg,.mp4,.mov,.avi,.mkv,.webm,.txt,.md,.json,.xml,.yml,.yaml,.zip,.rar,.7z,.tar,.gz,.tgz",
                                },
                                on: { change: _vm.handleFileSelect },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "attachments-list" },
                        [
                          _vm.attachments.length === 0
                            ? _c("div", { staticClass: "empty-state" }, [
                                _c("i", { staticClass: "fa fa-folder-open" }),
                                _vm._v(" "),
                                _c("p", [_vm._v("Nessun allegato")]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.attachments, function (attachment) {
                            return _c(
                              "div",
                              {
                                key: attachment.id,
                                staticClass: "attachment-item",
                              },
                              [
                                _c("div", { staticClass: "attachment-icon" }, [
                                  _c("i", {
                                    staticClass: "fa",
                                    class: attachment.icon,
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "attachment-info" }, [
                                  _c(
                                    "div",
                                    { staticClass: "attachment-name" },
                                    [_vm._v(_vm._s(attachment.file_name))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "attachment-meta" },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(attachment.formatted_size) +
                                          " • " +
                                          _vm._s(attachment.user.full_name) +
                                          " • " +
                                          _vm._s(attachment.created_at) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "attachment-actions" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "btn-icon",
                                        attrs: {
                                          href: attachment.download_url,
                                          title: "Download",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-download",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    attachment.is_own || _vm.canModify
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn-icon btn-delete",
                                            attrs: {
                                              type: "button",
                                              title: "Elimina",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteAttachment(
                                                  attachment.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-trash",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.uploadProgress.active
                        ? _c("div", { staticClass: "uploading-indicator" }, [
                            _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                            _vm._v(
                              "\n                        Caricamento " +
                                _vm._s(_vm.uploadProgress.done) +
                                "/" +
                                _vm._s(_vm.uploadProgress.total) +
                                "...\n                    "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.uploadProgress.errors.length > 0 &&
                      !_vm.uploadProgress.active
                        ? _c("div", { staticClass: "upload-errors-list" }, [
                            _c("p", { staticClass: "upload-errors-title" }, [
                              _vm._v("File non caricati:"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              _vm._l(
                                _vm.uploadProgress.errors,
                                function (err, idx) {
                                  return _c(
                                    "li",
                                    { key: "upload-err-" + idx },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(err.file.name) +
                                          " — " +
                                          _vm._s(err.message) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab === "overview",
                expression: "activeTab === 'overview'",
              },
            ],
            staticClass: "comment-input-container-fixed",
            class: { "is-expanded": _vm.commentEditorFocused },
          },
          [
            _vm.notificationRecipientLabel
              ? _c("p", { staticClass: "follower-notice" }, [
                  _vm._v(_vm._s(_vm.notificationRecipientLabel)),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.commentEditorFocused
              ? _c(
                  "div",
                  {
                    staticClass: "comment-placeholder",
                    class: { "is-dragover": _vm.commentDragover },
                    on: {
                      click: _vm.expandCommentEditor,
                      dragover: function ($event) {
                        $event.preventDefault()
                        _vm.commentDragover = true
                      },
                      dragleave: function ($event) {
                        $event.preventDefault()
                        _vm.commentDragover = false
                      },
                      drop: function ($event) {
                        $event.preventDefault()
                        return _vm.handleCommentDrop.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-pencil" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Scrivi un commento...")]),
                  ]
                )
              : _c(
                  "div",
                  { staticClass: "comment-editor-box" },
                  [
                    _c("wysiwyg-editor", {
                      ref: "commentEditor",
                      attrs: {
                        users: _vm.projectUsers,
                        attachments: _vm.attachments,
                        disabled: _vm.isSendingComment,
                        "task-id": _vm.subprojectId,
                        mode: "comment",
                        placeholder: "Scrivi un commento...",
                      },
                      on: {
                        mentioned: _vm.handleMention,
                        submit: _vm.sendComment,
                        "image-uploaded": _vm.handleImageUploaded,
                        "file-uploaded": _vm.handleDescriptionFileUploaded,
                        "preview-image": _vm.openImagePreview,
                        "upload-error": _vm.showError,
                        blur: _vm.collapseCommentEditor,
                      },
                      model: {
                        value: _vm.newComment,
                        callback: function ($$v) {
                          _vm.newComment = $$v
                        },
                        expression: "newComment",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "comment-send-inline",
                        attrs: {
                          type: "button",
                          disabled: _vm.isCommentEmpty || _vm.isSendingComment,
                        },
                        on: {
                          mousedown: function ($event) {
                            $event.preventDefault()
                            return _vm.sendComment.apply(null, arguments)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fa fa-paper-plane" })]
                    ),
                  ],
                  1
                ),
          ]
        ),
        _vm._v(" "),
        _vm.showAssigneeSelector
          ? _c(
              "div",
              {
                staticClass: "inline-modal-overlay",
                on: { click: _vm.closeAssigneeSelector },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "inline-modal",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "inline-modal-header" }, [
                      _c("h5", [_vm._v("Seleziona Assegnatari")]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close-btn",
                          on: { click: _vm.closeAssigneeSelector },
                        },
                        [_c("i", { staticClass: "fa fa-times" })]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inline-modal-body" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.assigneeSearchQuery,
                            expression: "assigneeSearchQuery",
                          },
                        ],
                        ref: "assigneeSearch",
                        staticClass: "search-input",
                        attrs: { type: "text", placeholder: "Cerca utente..." },
                        domProps: { value: _vm.assigneeSearchQuery },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.assigneeSearchQuery = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "user-list" },
                        _vm._l(_vm.filteredProjectUsers, function (user) {
                          return _c(
                            "div",
                            {
                              key: user.id,
                              staticClass: "user-item",
                              class: { selected: _vm.isUserAssigned(user.id) },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleAssignee(user)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "user-avatar-small" }, [
                                user.avatar
                                  ? _c("img", {
                                      attrs: {
                                        src: user.avatar,
                                        alt: user.full_name,
                                      },
                                    })
                                  : _c(
                                      "div",
                                      { staticClass: "avatar-initials-small" },
                                      [_vm._v(_vm._s(user.initials))]
                                    ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "user-name" }, [
                                _vm._v(_vm._s(user.full_name)),
                              ]),
                              _vm._v(" "),
                              _vm.isUserAssigned(user.id)
                                ? _c("i", { staticClass: "fa fa-check" })
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _vm.showImageModal
      ? _c(
          "div",
          {
            staticClass: "image-modal-overlay",
            on: { click: _vm.closeImageModal },
          },
          [
            _c(
              "div",
              {
                staticClass: "image-modal-content",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("div", { staticClass: "image-modal-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "image-modal-download",
                      attrs: { type: "button", title: "Scarica immagine" },
                      on: { click: _vm.downloadModalImage },
                    },
                    [_c("i", { staticClass: "fa fa-download" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "image-modal-close",
                      attrs: { type: "button" },
                      on: { click: _vm.closeImageModal },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "image-modal-img",
                  attrs: { src: _vm.modalImageUrl, alt: _vm.modalImageName },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "image-modal-name" }, [
                  _vm._v(_vm._s(_vm.modalImageName)),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading-spinner" }, [
      _c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" }),
      _vm._v(" "),
      _c("span", [_vm._v("Caricamento task...")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h6",
      {
        staticStyle: {
          "margin-bottom": "10px",
          color: "#aaa",
          "font-size": "13px",
        },
      },
      [
        _c("i", { staticClass: "fa fa-align-left" }),
        _vm._v(" Descrizione pianificazione\n                    "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h5",
      { staticClass: "section-title", staticStyle: { "margin-bottom": "8px" } },
      [
        _c("i", { staticClass: "fa fa-link" }),
        _vm._v(" Dipendenze\n                    "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", { staticClass: "section-title" }, [
      _c("i", { staticClass: "fa fa-align-left" }),
      _vm._v(" Descrizione\n                    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }